<template>
    <div class="sections">
        <div class="block nav">
            <div
                class="item"
                v-for="(title, index) in titles"
                :key="title"
                @click="sectionClickHandler(index)"
                :class="{'active': activeSection == index}"
                :title="title"
            >{{ title }}</div>
        </div>
        <div class="content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        titles: Array,
    },
    data() {
        return {
            activeSection: 0,
        }
    },
    methods: {
        sectionClickHandler(index) {
            this.activeSection = index
            this.$emit('changeSection', index)
        },
    },
}
</script>

<style scoped lang="scss">
$border-color: rgb(218, 218, 218);
.nav {
    display: flex;
    align-items: center;
    padding: 0 25 * $rem;
    margin-bottom: 12 * $rem;
    overflow: auto;
    justify-content: center;

    .item {
        float: left;
        height: 52 * $rem;
        line-height: 52 * $rem;
        color: #5f5f5f;
        background: white;
        font-size: 14 * $rem;
        padding: 0 30 * $rem;
        font-weight: 500;
        cursor: pointer;
        min-width: 124 * $rem;
        text-align: center;
        border: $rem solid $border-color;
        border-right: none;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        &:last-of-type {
            border-right: $rem solid $border-color;
            border-top-right-radius: 3 * $rem;
            border-bottom-right-radius: 3 * $rem;
        }

        &:first-of-type {
            border-top-left-radius: 3 * $rem;
            border-bottom-left-radius: 3 * $rem;
        }

        &:hover {
            cursor: pointer;
            filter: brightness(1.02);
        }
    }

    .active {
        color: white;
        font-weight: 500;
        background-color: $green-main;
    }
}

@media only screen and (max-width: 600px) {
    .nav {
        padding: 0;
        margin: 0;
        flex-wrap: wrap;

        .item {
            height: 40 * $rem;
            padding: 0 15 * $rem;
            min-width: initial;
            line-height: 40 * $rem;
            flex-shrink: 0;
            width: 50%;
            border: $rem solid $border-color;
        }
    }
}

@media only screen and (max-width: 455px) {
    .nav {
        flex-wrap: wrap;
    }
}
</style>
